import { Location } from '@angular/common';
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'app-move-details-container',
    template: ` <app-move-details (previous)="goToPrevious()" (next)="onSubmit()"></app-move-details> `,
    styles: [],
})
export class MoveDetailsContainer {
    constructor(private route: ActivatedRoute, private location: Location, private router: Router) {}

    public goToPrevious(): void {
        this.location.back();
    }

    public onSubmit(): void {
        this.router
            .navigate(['../contact-details'], {
                relativeTo: this.route,
            })
            .then();
    }
}
